<template>
  <div class="route-view-card ma-0 pa-12 fill-height d-flex flex-column">
    <span class="titulo mx-3"> Confirme os sinais clínicos apresentados </span>

    <v-row class="ma-0 mx-3 pa-0 d-flex align-end">
      <div class="subtitulo  mt-8"> Sinais clínicos apresentados no lote </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-nowrap align-center">
        <v-simple-checkbox v-model="boletimSanitario.blNotificacaoObrigatoria" color="#0090E9" />
        <span class="notificacao--obrigatoria ml-1">
          Existem sintomas de notificação obrigatória
        </span>
      </div>
    </v-row>
    <v-row class="ma-0 pa-0">
      <v-col v-for="(listaSinalClinico, idx) in chunkedRecords" :key="'listaSC__'+idx">
        <v-data-table hide-default-footer calculate-widths
                      no-data-text="Não foram encontradoss sinais clínicos para esse lote"
                      class="full-width elevation-2 mt-4"
                      :headers.sync="headersSinalCLinico" :items-per-page="-1"
                      :items="listaSinalClinico" :sort-by="['dtAplicacao']"
        >

        <template v-slot:item.dtAplicacao="{ item }">
          {{ item.dtAplicacao | dateFormat("DD/MM/Y") }}
        </template>
        </v-data-table>
      </v-col>
    </v-row>

  </div>

</template>

<script>
import {MOCKS, MODELS} from "../resources";
import {dateIsoToLocal, dateLocalToIso} from '@/filters/utils'

export default {
	name: "SinalClinicoBoletimSanitario",
  data: () =>({
    headersSinalCLinico: MODELS.HEADERS_SINAL_CLINICO,
  }),
  methods: {
    dateIsoToLocal,
    dateLocalToIso
  },
  computed: {
	  dividirTabela() {
	    const breakPoint = this.$vuetify.breakpoint
	    if(breakPoint.lgAndUp && this.boletimSanitario.sinaisClinicos.length > 18) return 3
      else if (breakPoint.mdAndUp && this.boletimSanitario.sinaisClinicos.length > 12) return 2
      return 1
    },
    chunkedRecords() {
	    if (this.boletimSanitario.sinaisClinicos.length === 0) return [[]]
      
      let sinaisClinicosOrdenados = this.boletimSanitario.sinaisClinicos.sort((a, b) => new Date(a.dtAplicacao) - new Date(b.dtAplicacao))
      
	    const chunkLength = Math.ceil(this.boletimSanitario.sinaisClinicos.length / this.dividirTabela)
	    return _.chunk(sinaisClinicosOrdenados, chunkLength)
    }
  },
	props: {
		btnContinuar: Boolean,
    boletimSanitario: {
      type: Object,
      required: true
    },
	}
}
</script>

<style scoped lang="scss">
.route-view-card {
	background-color: #F2F5F3;
}

.titulo {
  font-family: Roboto;
  font-size: 32px;
  color: #35565B;
  opacity: 0.8;
}

.subtitulo {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7B9596;
}

.notificacao--obrigatoria {
  font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 14px;
color: #799596;
}

</style>